export function login(emailAddress, password) {
  return {
    type: 'login',
    payload: {
      request: {
        url: '/auth/login',
        method: 'POST',
        data: {
          emailAddress: emailAddress,
          password: password
        }
      }
    }
  }
}

export function register(data) {
  return {
    type: 'register',
    payload: {
      request: {
        url: '/auth/register',
        method: 'POST',
        data: data
      }
    }
  }
}


export function activeEmail(data) {
  return {
    type: 'activeEmail',
    payload: {
      request: {
        url: '/auth/active-email',
        method: 'POST',
        data: data
      }
    }
  }
}

export function token() {
  return {
    type: 'token',
    payload: {
      request: {
        url: '/auth/token',
        method: 'GET'
      }
    }
  }
}

export function activeVendor(data) {
  return {
    type: 'activeVendor',
    payload: {
      request: {
        url: '/auth/active-vendor',
        method: 'POST',
        data: data
      }
    }
  }
}


// WEBPACK FOOTER //
// ./client/axios/auth.js